import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { ENV } from '../environments/environment';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // check to see if we're hitting a protected
    // API endpoint.  if so, add auth header.
    if(request.url.indexOf(ENV.apiUrl) > -1 && request.url.indexOf(`v${ENV.apiVersion}`) > -1)
    {
      this.storage.getItem("token").subscribe((token) => {
        request = request.clone({ setHeaders: {Authorization: `Bearer ${token.access_token}`} })
      });
    }

    return next.handle(request);
  }

  constructor(private storage: AsyncLocalStorage) {}
}



// WEBPACK FOOTER //
// ./src/interceptors/http-request-interceptor.ts